// FEAT-050 (MVP-9.1, MVP-1.2): user-facing role terminology for web.
// Mirrors api/src/utils/roleLabels.ts (the source of truth documented in
// docs/context/artifacts.yaml). The persisted role enum keeps the legacy
// `PATIENT` value, but every user-facing surface renders it as "Careseeker".

export const CARESEEKER_LABEL = 'Careseeker';
export const CAREGIVER_LABEL = 'Caregiver';
export const ADMIN_LABEL = 'Admin';

export type DisplayableRole = 'PATIENT' | 'CAREGIVER' | 'ADMIN' | string | null | undefined;

export function roleLabel(role: DisplayableRole): string {
  switch (role) {
    case 'CAREGIVER':
      return CAREGIVER_LABEL;
    case 'ADMIN':
      return ADMIN_LABEL;
    case 'PATIENT':
      return CARESEEKER_LABEL;
    default:
      return CARESEEKER_LABEL;
  }
}
